module.exports = __webpack_public_path__ + "static/fonts/barlowcondensed-medium-webfont.9409e7a.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/barlowcondensed-medium-webfont.eot
// module id = 115
// module chunks = 0